import {searchFiltersSelector, searchSelector} from "./selectors";
import SearchRepository from "../_repositories/searchRepository";
import {
    clearSearchFiltersAction,
    clearSearchItemsAction,
    clearSearchSecondaryFilterAction,
    incrementSearchTrendingCategoriesCount,
    receiveSearchItemsAction, requestSearchGeoLocationAction,
    requestSearchItemsAction,
    resetSearchTrendingCategoriesCount,
    setSearchFilterTypeAction,
    setSearchGeoLocationAction,
    setSearchLocationAction,
    setSearchNoResultsFound,
    setSearchQueryAction,
    setSearchSecondaryFilterAction,
    setSearchView
} from "./actions";
import {getLocation, apiModelNameToClientModelName} from "../_helpers/utils";
import {addDataAction} from "../_data/actions";
import * as _ from "lodash";
import {GeoState} from "../_definitions/styleteq";
import {SearchView} from "./reducers";
import {push} from "react-router-redux";
import {SearchRoutes} from "../routes";
import * as queryString from "query-string";
import {professionalFilter} from "./components/SearchFiltersComponent";

export enum SearchAddressType{
    LOCATION,
    PROXIMITY,
    NONE
}

export function changeSearchFilterType(type: string) {
    return (dispatch, getState) => {
        if (searchFiltersSelector(getState()).typeFilter != type) {
            dispatch(clearSearchSecondaryFilterAction());
            dispatch(setSearchFilterTypeAction({type: type}));
        }
    }
}

export function pushSearch() {
    return (dispatch, getState) => {
        const data = searchSelector(getState());
        const filter = data.filters;
        const type = filter.typeFilter;
        const secondaryFilters = filter.secondaryFilters.length ? filter.secondaryFilters : null;
        dispatch(push(SearchRoutes.query(data.query, data.geo, type, secondaryFilters, null, null)));
    };
}

export function searchFromUrl(url: string) {
    return (dispatch) => {
        if (url.length == 0) {
            dispatch(clearSearchFiltersAction());
            dispatch(setSearchView({view: SearchView.TRENDING}));
            dispatch(searchTrending());
        }
        else {
            const query = queryString.parse(url, {arrayFormat: 'bracket'});
            if (query['q'])
                dispatch(setSearchQueryAction({query: query['q']}));
            if (query['resource'])
                dispatch(setSearchFilterTypeAction({type: query['resource']}));
            if (query['filter'])
                dispatch(setSearchSecondaryFilterAction({secondaryFilters: query['filter']}));
            if (query['geo[address]'])
                dispatch(setSearchLocationAction({location: query['geo[address]']}));
            if (query['geo[longitude]'])
                dispatch(setSearchGeoLocationAction({
                    coords: {
                        longitude: parseFloat(query['geo[longitude]']),
                        latitude: parseFloat(query['geo[latitude]'])
                    }
                }));
            dispatch(searchFromStateValues());
        }
    }
}


export function searchTrending(addressType: SearchAddressType = SearchAddressType.LOCATION) {
    return (dispatch, getState) => {
        let geo = searchSelector(getState()).geo;
        if (addressType == SearchAddressType.LOCATION && geo.address.trim().length == 0)
            addressType = SearchAddressType.PROXIMITY;

        const proc = () => {
            dispatch(resetSearchTrendingCategoriesCount());
            dispatch(clearSearchItemsAction());
            dispatch(requestSearchItemsAction());

            let geo = searchSelector(getState()).geo;
            if (addressType == SearchAddressType.NONE)
                geo = null;

            searchTrendingCategory(dispatch, 'style', 6, addressType, geo);
            searchTrendingCategory(dispatch, 'special', 6, addressType, geo);
            searchTrendingCategory(dispatch, 'salon', 4, addressType, geo);
            searchTrendingCategory(dispatch, 'user', 5, addressType, geo);
        };

        if (addressType == SearchAddressType.PROXIMITY && geo.longitude == null && geo.latitude == null)
            getLocationForSearch(dispatch, proc);
        else
            proc();
    };
}

export function searchFromStateValues() {
    return (dispatch, getState) => {
        let geo = searchSelector(getState()).geo;
        const proc = () => {
            dispatch(setSearchView({view: SearchView.SEARCH}));
            dispatch(clearSearchItemsAction());
            dispatch(requestSearchItemsAction());
            dispatch(search());
        };

        if (geo.longitude == null && geo.latitude == null)
            getLocationForSearch(dispatch, proc);
        else
            proc();
    };
}

export function search() {
    return (dispatch, getState) => {
        const data = searchSelector(getState());
        const filter = data.filters;
        const type = filter.typeFilter;
        const secondaryFilters = filter.secondaryFilters.length ? filter.secondaryFilters : null;
        const meta = data.meta;

        SearchRepository.search(data.query, data.geo, type, secondaryFilters, meta ? meta.nextPage : 1).then(data => {
            if (data.results.length)
                addSearchData(dispatch, data);
            else {
                dispatch(setSearchView({view: SearchView.TRENDING}));
                dispatch(setSearchNoResultsFound());
                dispatch(searchTrending());
            }
        });
    }
}

//helpers
function searchTrendingCategory(dispatch, category: string, perPage: number, addressType: SearchAddressType, geo: GeoState) {
    let _geo = _.cloneDeep(geo);
    const secondaryFilters = category == 'user' ? _.cloneDeep(professionalFilter).splice(1) : null;

    if (addressType == SearchAddressType.PROXIMITY)
        _.chain(_geo).set('address', null).value();

    SearchRepository.searchTrendingCategory(category, _geo, perPage, secondaryFilters).then(data => {
        dispatch(incrementSearchTrendingCategoriesCount());
        if (data.results.length)
            addSearchData(dispatch, data);
        dispatch((dispatch, getState) => {
            const search = searchSelector(getState());
            if (search.trendingCategoriesCount == 4 && search.results.isEmpty()) {
                if (addressType == SearchAddressType.LOCATION)
                    dispatch(searchTrending(SearchAddressType.PROXIMITY));
                else if (addressType == SearchAddressType.PROXIMITY)
                    dispatch(searchTrending(SearchAddressType.NONE));
            }
        });
    });
}

function addSearchData(dispatch, data) {
    const typeId = {
        'User': 1,
        'Salon': 2,
        'Special': 3,
        'Style': 4,
        'Booth': 5,
    };
    const items = data.results.map((data) => {
        return {
            ...data,
            model_id: data.entity_properties.id,
            id: parseInt("" + data.entity_properties.id + typeId[data.type])
        };
    });
    _.chain(items)
        .groupBy(d => d.type)
        .map((value, key) => {
            return {
                resource: apiModelNameToClientModelName(key).toLowerCase(),
                value: value.map(v => v.entity_properties)
            };
        })
        .forEach((map) => {
            dispatch(addDataAction({
                resource: map.resource,
                data: map.value
            }));
        }).value();
    dispatch(receiveSearchItemsAction({data: items, meta: data.meta}));
}

function getLocationForSearch(dispatch, callback: () => void) {
    dispatch(requestSearchGeoLocationAction());
    const location = getLocation((position: Position) => {
        dispatch(setSearchGeoLocationAction({coords: position.coords}));
        callback();
    }, (error: PositionError) => {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                console.log("User has denied the request for GeoLocation.");
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                break;
            case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                break;
            default:
                console.log("An unknown error occurred.");
                break;
        }
        dispatch(setSearchGeoLocationAction({coords: {latitude: null, longitude: null}}));
        callback();
    });
}


// WEBPACK FOOTER //
// ./app/client/search/middlewares.ts